/* eslint-disable no-console */
/* eslint-disable @typescript-eslint/no-empty-function */
import { useAwsFlagActive } from 'Modules/FeatureFlag'
import { useRef, useEffect } from 'react'

type LoggerFunction = (...args: any[]) => void

export const useLogging = (prefix?: string) => {
  const isLoggingActive = useAwsFlagActive('useLogging')
  const loggerRef = useRef<{
    info: LoggerFunction
    log: LoggerFunction
    warn: LoggerFunction
    error: LoggerFunction
  }>()

  useEffect(() => {
    const info: LoggerFunction = (...args) => {
      if (isLoggingActive)
        console.info(`%c${prefix}: `, ...args, 'color: orange')
    }

    const log: LoggerFunction = (...args) => {
      if (isLoggingActive) console.log(`${prefix}: `, ...args)
    }

    const warn: LoggerFunction = (...args) => {
      if (isLoggingActive) console.warn(...args)
    }

    const error: LoggerFunction = (...args) => {
      if (isLoggingActive) console.error(...args)
    }
    loggerRef.current = {
      info,
      log,
      warn,
      error,
    }
  }, [isLoggingActive, prefix])

  const logger = loggerRef.current || {
    info: () => {},
    log: () => {},
    warn: () => {},
    error: () => {},
  }

  return logger
}
